import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <MediaSection />
        <AppSection />
        <FaqSection />
        <AboutSection />
        <UpdatesSection />
        <ContactSection />
        <CardsSection />
        <IndexSection />
        <RankingSection />
        <CommentsSection />
        <FeaturesSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}